import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  cerrarSesion() {


    Swal.fire({
      title: '¿Confima cerrar la sesión?',
      text: '',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, Cerrar!',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {

        this.router.navigate(['/login']);
        sessionStorage.clear();

      }

    });

  }

}
